import { render } from "./pro-img.vue?vue&type=template&id=5cfbc808&scoped=true"
import script from "./pro-img.vue?vue&type=script&lang=js"
export * from "./pro-img.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5cfbc808"

export default script